<template>
	<div class="pay_panel">
		<transition name="fade" @after-leave="afterLeave">
			<div v-if="dialogData.dialogStatus">
				<div class="panel_shade"></div>
				<div class="askanserprice_box_panel">
					<div class="askanserprice_box_top" style="text-align: center;line-height: 250px;">
						<div class="askanserprice_box_top_text">请支付</div>
						<div class="askanserprice_box_top_close" @click="cancel">×</div>
					</div>
					<div class="askanserprice_box_con">
						<div class="askanserprice_box_con_methods_panel">
							<div class="askanserprice_box_con_methods_li"
								:class="{askanserprice_active : payWay == 'pay_ali'}"
								@click="patmethods('pay_ali')">
								<div class="askanserprice_box_con_methods_li_img">
									<img src="../img/icon_zfb.png" alt="">
								</div>
								支付宝支付
							</div>
							<div class="askanserprice_box_con_methods_li"
								:class="{askanserprice_active : payWay == 'pay_wx'}"
								@click="patmethods('pay_wx')">
								<div class="askanserprice_box_con_methods_li_img">
									<img src="../img/icon_weixin.png" alt="">
								</div>
								微信支付
							</div>
						</div>
						<div class="askanserprice_box_erweima">
							<!-- 支付宝支付 -->
							<div id="alipayCodeBox" v-if="payWay == 'pay_ali'">
								<div class="askanserprice_box_code_box">
										<div class="askanserprice_box_code">
											<div class="askanserprice_refresh" v-show="ifAlipayCodeRefresh">
												<div class="askanserprice_refresh_img" @click="refreshCode(1)">
													<img src="../img/icon_sx.png" alt="">
												</div>
											</div>
											<div>
												<vue-qr
													colorLight="#fff"
													:margin="0"
													:text="alipayText"
													:dotScale='0.9'
													:logoSrc="logoUrl"
													:logoScale="50"
													:size="180">
												</vue-qr>
											</div>
										</div>
										<div class="askanserprice_box_text">手机扫一扫支付</div>
								</div>
								<div class="askanserprice_time_box">
									<div class="askanserprice_money">
										<span style="color: #f30000;font-size: 18px">￥</span>
										{{ orderPrice | numFilter }}
										<span style="color: #666666;font-size: 20px">元</span>
									</div>
									<div class="askanserprice_time">二维码过期倒计时 <span>{{ alipayCodeInvalidTime }}</span> s</div>
								</div>
							</div>
							<!-- 微信支付 -->
							<div id="wenxinCodeBox" v-if="payWay == 'pay_wx'">
								<div class="askanserprice_box_code_box">
									<div class="askanserprice_box_code">
										<div class="askanserprice_refresh" v-show="ifWechatCodeRefresh">
											<div class="askanserprice_refresh_img" @click="refreshCode(2)">
												<img src="../img/icon_sx.png" alt="">
											</div>
										</div>
										<div>
											<vue-qr
												colorLight="#fff"
												:margin="0"
												:text="wechatText"
												:dotScale='0.9'
												:logoSrc="logoUrl"
												:logoScale="50"
												:size="180">
											</vue-qr>
										</div>
									</div>
									<div class="askanserprice_box_text">手机扫一扫支付</div>
								</div>
								<div class="askanserprice_time_box">
									<div class="askanserprice_money">
										<span style="color: #f30000;font-size: 18px">￥</span>
										{{ orderPrice | numFilter }}
										<span style="color: #666666;font-size: 20px">元</span>
									</div>
									<div class="askanserprice_time">二维码过期倒计时 <span>{{ wechatCodeInvalidTime }}</span> s</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			
			</div>
		</transition>
	</div>
</template>
<script>
import { getLocalOrderNumData } from '@/utils/storage'
import vueQr from 'vue-qr'
import secret from '@/utils/secret'

export default {
	name: 'payPanel',
	props: {
		dialogData: {
			type: Object,
			require: true
		}
	},
	components: {
		vueQr
	},
	filters: {
	  numFilter(value) {
			if (value == null) {
		    value = 0
			}
			if (value < 1 && value > 0) {
				return value
			} else {
				let tempVal = parseFloat(value).toFixed(3)
		    let realVal = tempVal.substring(0,  tempVal.length - 1)
		    return realVal
			}
	  }
	},
	computed: {
		orderStatusData () {
			return this.orderStatus
		},
		orderPriceStatusData () {
			return this.orderPriceStatus
		},
	},
	watch: {
		dialogData: {
			handler (newData, oldData) {
				if (newData.dialogStatus) {
					this.orderPayNo = newData.orderNo
					if (this.$utils.isNotEmpty(this.orderPayNo)) {
						// 获取订单金额
						this.getOrderPrice()
						// 获取支付链接
						if (this.payWay === 'pay_ali') {
							this.alipayTimerDown()
						} else {
							this.wechatTimerDown()
						}
					} else {
						this.$alert('未存在订单！', '提示', {
							confirmButtonText: '确定',
							type: 'warning',
							showClose: false,
							callback: action => {
							}
						})
					}
				} else {
					clearInterval(this.orderTimer)
					clearInterval(this.orderPriceTimer)
				}
			},
      deep: true,
      immediate: true
		},
		orderStatusData: {
			handler (newData, oldData) {
				if (newData == 'success') { // 支付完成 关闭轮询
					clearInterval(this.orderTimer)
					this.dialogData.dialogStatus = false
					this.dialogData.payStatus = 'success'
				} else if (newData == 'wait') { // 支付未完成开启轮询
				if (this.$utils.isNotEmpty(this.orderPayNo)) {
					this.orderTimer = setInterval(() => {
						this.roundRequestTime = this.roundRequestTime - 2
						if (this.roundRequestTime > 0) {
							setTimeout(this.getOrderStatus(), 0)
						}
					}, 3000)
				}
				} else { // 失败
				}
				this.$once('hook:beforeDestroy', () => {
					clearInterval(this.orderTimer)
				})
			}	
		},
		orderPriceStatusData: {
			handler (newData, oldData) {
				if (newData == 'success') { // 支付宝支付链接轮询
					clearInterval(this.orderPriceTimer)
					// 获取并设置订单状态
					this.orderStatus = 'wait'
					this.loadAlipayText()
				} else { // 失败
					if (this.$utils.isNotEmpty(this.orderPayNo)) {
						this.orderPriceTimer = setInterval(() => {
							this.orderPriceTime = this.orderPriceTime - 0.5
							if (this.orderPriceTime > 0) {
								setTimeout(this.getOrderPrice(), 0)
							} else {
								clearInterval(this.orderTimer)
								clearInterval(this.orderPriceTimer)
								this.$alert('无效订单，请重新选择商品！', '提示', {
									confirmButtonText: '确定',
									type: 'warning',
									showClose: false,
									callback: action => {
										this.$router.push({path: '/search'})
									}
								})
							}
						}, 500)
					}
				}
				this.$once('hook:beforeDestroy', () => {
					clearInterval(this.orderPriceTimer)
					clearInterval(this.orderTimer)
				})
			}
		}
	},
	data () {
		return {
			//  2019年7月11日 17:24:57 新加
			panelShadeHeight: '100%',
			panelShadeTopHeight: '100%',
			payWay: 'pay_ali', // pay_ali-支付宝支付 pay_wx-微信支付
			logoUrl: require('../../assets/cabp_logo.png'),
			alipayText: '支付宝码已过期，请重新生成',
			wechatText: '微信码已过期，请重新生成',
			roundRequestTime: 240, // 轮询查询
			alipayCodeInvalidTime: 120,
			wechatCodeInvalidTime: 120,
			ifAlipayCodeRefresh: false,
			ifWechatCodeRefresh: false,
			roundRequestTimer: '',
			alipayTimer: '',
			wechatTimer: '',
			orderStatus: '', // success-支付成功 wait-支付中 failed-支付失败
			orderPayNo: '',
			orderTimer: '',
			orderPrice: 0,
			orderPriceStatus: '',
			orderPriceTime: 3,
			orderPriceTimer: '',
			roundResponeData: '',
			alipayStatus: '',
			alipayUrlTime: 3,
			wechatUrlTime: 3,
			alipayUrlTimer: '',
			wechatUrlTimer: '',
		}
	},
	methods:{
		/** 设置遮罩高度 */
		windowScroll () {
				this.panelShadeHeight = document.body.scrollHeight + 'px'
		},
		/** 支付方式切换 */
		patmethods (changeContent) {
				this.payWay = changeContent
				if (changeContent === 'pay_ali') { // 支付宝
					if (this.alipayCodeInvalidTime === 120) {
						this.alipayTimerDown()
						this.loadAlipayText()
					}
				} else if (changeContent === 'pay_wx') {
					if (this.wechatCodeInvalidTime === 120) {
						this.wechatTimerDown()
						this.loadWechatText()
					}
				} else {
				}
		},
		/** 点击刷新 */
		refreshCode (index) {
				if (index === 1) { // 支付宝
						this.alipayTimerDown()
						this.loadAlipayText()
						this.ifAlipayCodeRefresh = false
				} else if (index === 2) { // 微信
						this.wechatTimerDown()
						this.loadWechatText()
						this.ifWechatCodeRefresh = false
				} else {
				}
				this.roundRequestTime = 240
		},
		/** 支付宝倒计时 */
		alipayTimerDown () {
				clearInterval(this.alipayTimer)
				this.alipayTimer = setInterval(() => {
					this.alipayCodeInvalidTime--
					if (this.alipayCodeInvalidTime <= 0) {
						clearInterval(this.alipayTimer)
						this.ifAlipayCodeRefresh = true
						this.alipayCodeInvalidTime = 120
						this.wechatText = '码已过期，请重新生成'
					}
				}, 1000)
		},
		/** 微信倒计时 */
		wechatTimerDown () {
				clearInterval(this.wechatTimer)
				this.wechatTimer = setInterval(() => {
					this.wechatCodeInvalidTime--
					if (this.wechatCodeInvalidTime <= 0) {
						clearInterval(this.wechatTimer)
						this.ifWechatCodeRefresh = true
						this.wechatCodeInvalidTime = 120
						this.wechatText = '码已过期，请重新生成'
					}
				}, 1000)
		},
		/** 去支付页面 */
		toAlipayPage () {
				let alipayPage = this.$router.resolve({ 
						name: 'alipay'
				})  
				window.open(alipayPage.href, '_blank')
		},
		/** 跳转支付完成页 */
		toPayFinishPage () {
			let params = {
				payWay: secret.encryptionText(this.payWay),
				outTradeNo: secret.encryptionText(this.roundResponeData.outTradeNo),
				tradeNo: secret.encryptionText(this.roundResponeData.tradeNo),
				tradeStatus: secret.encryptionText(this.roundResponeData.tradeStatus),
				totalAmount: secret.encryptionText(this.orderPrice)
			}
			this.$router.replace({name: 'payfinish', query: params})
		},
		/** 获取支付宝支付链接 */
		loadAlipayText () {
			if (this.$utils.isNotEmpty(this.orderPayNo)) {
				let params = {
					outTradeNo: this.orderPayNo,
					appCode: this.$constant.COMMON_APPCODE
				}
				let option = this.$utils.getAxiosOption('get', '/onlinePay/web/aliQrCode', params, '')
				this.$axios(option).then(response => {
						let resultData = response.data
						let errorInfo = resultData.errorInfo
						this.alipayStatus = errorInfo
						if (errorInfo == 'success') {
							this.alipayText = resultData.data
						}
				}).catch(function (error) {console.log(error)})
			}
		},
		/** 获取微信支付链接 */
		loadWechatText () {
			if (this.$utils.isNotEmpty(this.orderPayNo)) {
				let params = {
					payOrderNo: this.orderPayNo,
					appCode: this.$constant.COMMON_APPCODE
				}
				let option = this.$utils.getAxiosOption('post', '/onlinePay/web/wxWebPay', params, '')
				this.$axios(option).then(response => {
					let resultData = response.data
					let errorInfo = resultData.errorInfo
					if (errorInfo == 'success') {
					this.wechatText = resultData.data
					}
				}).catch(function (error) {console.log(error)})
			}
		},
		/** 获取订单状态 */
		getOrderStatus () {
			if (this.$utils.isNotEmpty(this.orderPayNo)) {
				let params = {
					payOrderNo: this.orderPayNo,
					payWay: this.payWay,
					appCode: this.$constant.COMMON_APPCODE
				}
				let option = this.$utils.getAxiosOption('post', 'onlinePay/web/selectPayOrderDate', params, '')
				this.$axios(option).then(response => {
					let resultData = response.data
					let errorInfo = resultData.errorInfo
					if (errorInfo === 'success') {
						this.orderStatus = resultData.data.tradeStatus
						this.roundResponeData = resultData.data
					}
				}).catch(function (error) {console.log(error)})
			}
		},
		/** 获取订单支付金额 */
		getOrderPrice () {
			if (this.$utils.isNotEmpty(this.orderPayNo)) {
				let params = {
					payNo: this.orderPayNo
				}
				let option = this.$utils.getAxiosOption('get', '/onlinePay/web/selectPayAmount', params, '')
				this.$axios(option).then(response => {
					let resultData = response.data
					let errorInfo = resultData.errorInfo
					this.orderPriceStatus = errorInfo
					if (errorInfo == 'success') {
						this.orderPrice = resultData.data
					}
				}).catch(function (error) {console.log(error)})
			}
		},
		cancel(e){
			e.preventDefault()
			this.dialogData.dialogStatus = false
			this.$emit('close')
		},
		afterLeave () {
			this.$emit('closed')
		}
	},
	mounted () {
	},
	destroyed () {
		window.removeEventListener('scroll', this.windowScroll)
	}
}
</script>
<style scoped>
	.panel_shade {
			position: absolute;
			left: 0px;
			top: 0px;
			opacity: .5;
			z-index: 2000;
			background-color: rgb(0, 0, 0); 
			width: 100%;
			height: 100%;
	}
	.askanserprice_box_panel{
			width: 790px;
			height: 550px;
			background: white;
			border: 1px solid #ccc;
			margin: 0 auto;
			position: fixed;
			box-sizing: border-box;
			left: 30%;
			top: 200px;
			padding: 10px;
			border-radius: 10px;
			z-index: 2001;
	}
	.askanserprice_box_top{
			width: 100%;
			height: 50px;
			border-bottom: 1px solid #ccc;
			margin-bottom: 40px;
			display: flex;
	}
	.askanserprice_box_top_text{
			width: 90%;
			height: 50px;
			line-height: 50px;
			text-align: left;
			color: #333;
			padding-left: 30px;
	}
	.askanserprice_box_top_close{
			width: 10%;
			height: 50px;
			line-height: 50px;
			text-align: center;
			color: #999;
			font-size: 30px;
			cursor: pointer;
	}
	.askanserprice_box_con{
			width: 708px;
			height: 420px;
			margin: 0 auto;
			border: 1px solid #e4d9cf;
			box-sizing: border-box;
			display: flex;
			justify-content: space-between;
			border-radius: 3px;
	}
	.askanserprice_box_con_methods_panel{
			width: 222px;
			background: #f4f0ec;
	}
	.askanserprice_box_con_methods_li{
			width: 100%;
			height: 80px;
			line-height: 80px;
			color: #333;
			font-size: 18px;
			display: flex;
	}
	.askanserprice_active{
			background: white;
	}
	.askanserprice_box_con_methods_li_img{
			width: 32px;
			height: 32px;
			margin: 25px 10px 0 40px;
			display: flex;
	}
	.askanserprice_box_con_methods_li_img img{
			width: 100%;
			height: 100%;
	}
	.askanserprice_box_erweima{
			width: 486px;
			height: 420px;
	}
	.askanserprice_box_code_box{
			width: 180px;
			height: 210px;
			box-sizing: border-box;
			margin: 47px 0 0 152px;
	}
	.askanserprice_box_code{
			width: 180px;
			height: 180px;
			border: 1px solid #e4d9cf;
			padding: 5px;
			box-sizing: border-box;
			padding: 5px;
			position: relative;
	}
	.askanserprice_box_code img{
			width: 100%;
			height: 100%;
	}
	.askanserprice_refresh{
			background: rgba(0,0,0,0.5);
			z-index: 99999;
			position: absolute;
			top: 5px;
			bottom: 5px;
			left: 5px;
			right: 5px;
	}
	.askanserprice_refresh_img{
			width: 40px;
			height: 40px;
			margin: 64px;
			display: flex;
			cursor: pointer;
	}
	.askanserprice_box_text{
			width: 100%;
			height: 30px;
			line-height: 30px;
			text-align: center;
			font-size: 12px;
			color: #666;
	}
	.askanserprice_time_box{
			width: 100%;
			height: 150px;
	}
	.askanserprice_money{
			width: 100%;
			height: 80px;
			line-height: 100px;
			font-size: 32px;
			color: #f30000;
			text-align: center;
	}
	.askanserprice_time{
			width: 100%;
			height: 80px;
			color: #666;
			font-size: 21px;
			line-height: 80px;
			text-align: center;

	}
	.askanserprice_time span{
			padding: 0 5px;
			box-sizing: border-box;
			height: 21px;
			line-height: 21px;
			color: #fff;
			background: #666;
			font-size: 17px;
			display: inline-block;
	}
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}
	.popup-parent--hidden {
		overflow: hidden;
	}
</style>


// WEBPACK FOOTER //
// src/components/commonPayPanel/payPanel.vue